export const slackNotificationChannelQueryKeys = {
  all: ['slack-notification-channel'] as const,
  current: () => [...slackNotificationChannelQueryKeys.all, 'current'] as const,
  availableChannelPages: () =>
    [
      ...slackNotificationChannelQueryKeys.all,
      'available-channel-pages',
    ] as const,
};
